'use client';

import Image from 'next/image';
import { Link } from '@/app/[lang]/(main)/components/shared/PrivateLink/ServerLink';
import { runtimeConfig } from '@/config/runtime-config';
import { isMezia, meziaTheme } from '@/config/brand';
import { markHomeFeedRevalidate } from '@/hooks/homeFeedRevalidateSignal';

type Props = {
  locale: string;
  title: string;
};

export function LogoLink({ locale, title }: Props) {
  if (meziaTheme) {
    return (
      <Link title={title} href='/' className='flex items-center' onClick={() => markHomeFeedRevalidate()}>
        <Image
          width={466}
          height={100}
          priority
          alt={runtimeConfig.name[locale] || title}
          src={locale === 'he' ? '/assets/images/mezia_logo_new.svg' : '/assets/images/mezia_normal.png'}
          className='w-auto shrink-0 h-[30px] min-[1200px]:h-[48px]'
        />
      </Link>
    );
  }

  return (
    <Link title={title} href='/' className='flex items-center gap-[12px]' onClick={() => markHomeFeedRevalidate()}>
      <Image
        width={48}
        height={48}
        alt={title}
        src={runtimeConfig.logoUrl}
        unoptimized
        className='lg:h-[48px] lg:w-[48px] h-[30px] w-[30px] max-[1200px]:w-[30px]! max-[1200px]:h-[30px]!'
      />
      <Image
        width={132}
        height={28}
        alt={runtimeConfig.name[locale] || ''}
        src={isMezia ? '/assets/icons/logo-text-mezia.png' : '/assets/icons/logo-text.svg'}
        className='lg:h-[28px] lg:w-[132px] max-[1200px]:w-[85px]! max-[1200px]:h-[18px]! h-[18px] w-[85px]'
      />
    </Link>
  );
}
